import React from 'react';

const LoadingState = ({ text = 'Cargando...', fullScreen = false, className = '' }) => {
  const containerClass = fullScreen
    ? 'fixed inset-0 bg-white/90 flex items-center justify-center z-50'
    : 'flex min-h-[200px] items-center justify-center';

  return (
    <div className={`${containerClass} ${className}`.trim()}>
      <div className="flex flex-col items-center">
        <div className="w-16 h-16 mb-4 border-4 border-[#152b5a] border-t-transparent rounded-full animate-spin"></div>
        <p className="text-[#152b5a] font-playfair text-xl">{text}</p>
      </div>
    </div>
  );
};

export default LoadingState;
